import { getRowsFromTagsFileContent } from "@features/administration/products/EditProduct/nodeTagsHelper"
import { NodeTagsFormValues } from "@features/administration/products/EditProduct/NodeTagsForm/NodeTagsForm"

export const getDefaultValues = (tagsResponse: string | undefined): NodeTagsFormValues => {
  const rows = getRowsFromTagsFileContent(tagsResponse ?? "")

  const parsedRows = rows.map((row) => ({
    type: row.Type,
    name: row.Name,
    value: row.Value,
    description: row.Description,
  }))

  return { rows: parsedRows }
}
